// Tailwind Configuration
if (typeof tailwind !== 'undefined') {
  tailwind.config = {
    darkMode: "class",
    theme: {
      extend: {
        "colors": {
          "sonic-navy": "#001F3F",
          "sonic-neon": "#CDE255",
          "on-tertiary-container": "#465f82",
          "primary": "#586400",
          "on-error-container": "#93000a",
          "surface-container": "#eeeeee",
          "secondary-container": "#bdd6ff",
          "on-primary-fixed": "#191e00",
          "tertiary": "#476083",
          "outline": "#777964",
          "on-secondary-fixed": "#001c3a",
          "on-primary-container": "#576300",
          "surface-dim": "#dadada",
          "secondary-fixed": "#d4e3ff",
          "on-error": "#ffffff",
          "surface-container-high": "#e8e8e8",
          "on-primary-fixed-variant": "#424b00",
          "primary-fixed": "#d8ed5f",
          "inverse-on-surface": "#f0f1f1",
          "tertiary-fixed-dim": "#afc8f0",
          "tertiary-container": "#c2d9ff",
          "surface-tint": "#586400",
          "surface-bright": "#f9f9f9",
          "outline-variant": "#c7c8b1",
          "on-surface-variant": "#464836",
          "on-primary": "#ffffff",
          "on-tertiary-fixed": "#001c3a",
          "on-background": "#1a1c1c",
          "error-container": "#ffdad6",
          "background": "#f9f9f9",
          "on-surface": "#1a1c1c",
          "on-tertiary": "#ffffff",
          "error": "#ba1a1a",
          "primary-fixed-dim": "#bcd146",
          "surface-container-low": "#f3f3f4",
          "secondary-fixed-dim": "#afc8f0",
          "inverse-surface": "#2f3131",
          "surface-variant": "#e2e2e2",
          "on-secondary-container": "#445d80",
          "secondary": "#476083",
          "on-secondary-fixed-variant": "#2f486a",
          "inverse-primary": "#bcd146",
          "surface-container-lowest": "#ffffff",
          "on-secondary": "#ffffff",
          "surface-container-highest": "#e2e2e2",
          "tertiary-fixed": "#d4e3ff",
          "primary-container": "#cde255",
          "on-tertiary-fixed-variant": "#2f486a",
          "surface": "#f9f9f9"
        },
        "borderRadius": {
          "DEFAULT": "0px",
          "lg": "0px",
          "xl": "0px",
          "full": "9999px"
        },
        "fontFamily": {
          "headline": ["Epilogue"],
          "body": ["Outfit"],
          "label": ["Outfit"],
          "mono": ["JetBrains Mono"]
        }
      }
    }
  };
}

// Global Tab Switcher Function
function switchTab(tab) {
  if (window._popupTabsHandler && typeof window._popupTabsHandler.switchTab === 'function') {
    window._popupTabsHandler.switchTab(tab);
    return;
  }
  const ccCarousel = document.getElementById('cc-carousel');
  const vinylCarousel = document.getElementById('vinyl-carousel');
  const tabCc = document.getElementById('tab-cc');
  const tabVinyl = document.getElementById('tab-vinyl');

  if (!ccCarousel || !vinylCarousel || !tabCc || !tabVinyl) return;

  if (tab === 'cc') {
    ccCarousel.style.display = 'block';
    vinylCarousel.style.display = 'none';
    tabCc.classList.add('is-active', 'active');
    tabVinyl.classList.remove('is-active', 'active');
  } else {
    ccCarousel.style.display = 'none';
    vinylCarousel.style.display = 'block';
    tabVinyl.classList.add('is-active', 'active');
    tabCc.classList.remove('is-active', 'active');
  }
}

// Interactive Page Scripts
document.addEventListener('DOMContentLoaded', function() {
  // Mobile Hamburger Menu Toggle
  const btn = document.getElementById('hamburger-btn');
  const menu = document.getElementById('mobile-menu');
  const iconSpan = btn ? btn.querySelector('.material-symbols-outlined') : null;

  if (btn && menu) {
    btn.addEventListener('click', function() {
      const isOpen = menu.style.display === 'flex';
      menu.style.display = isOpen ? 'none' : 'flex';
      if (iconSpan) {
        iconSpan.textContent = isOpen ? 'menu' : 'close';
      }
    });
  }

  // Tape Marquee Loop
  document.querySelectorAll('.tape-track').forEach(function(track) {
    var img = track.querySelector('img');
    if (!img) return;
    function startTape() {
      var imgW = img.naturalWidth * (48 / img.naturalHeight) || 300;
      var copies = Math.ceil((window.innerWidth * 2) / imgW) + 2;
      var existing = track.querySelectorAll('img').length;
      for (var i = existing; i < copies; i++) {
        var clone = img.cloneNode(true);
        track.appendChild(clone);
      }
      var unitW = imgW;
      var pos = 0;
      var speed = 0.5;
      var last = null;
      function step(ts) {
        if (last !== null) {
          var dt = ts - last;
          pos -= speed * dt / 16.67;
          if (pos <= -unitW) pos += unitW;
          track.style.transform = 'translateX(' + pos + 'px)';
        }
        last = ts;
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (img.complete && img.naturalWidth) {
      startTape();
    } else {
      img.onload = startTape;
    }
  });

  // Hero Slideshow
  const heroSection = document.getElementById('hero-section');
  if (heroSection) {
    const heroSlides = [];
    if (heroSlides.length > 0) {
      const bgContainer = document.createElement('div');
      bgContainer.id = 'hero-bg-slides';
      heroSection.insertBefore(bgContainer, heroSection.firstChild);

      const slideEls = heroSlides.map((src, i) => {
        const el = document.createElement('div');
        el.className = 'hero-slide' + (i === 0 ? ' active' : '');
        el.style.backgroundImage = `url(${src})`;
        bgContainer.appendChild(el);
        return el;
      });

      const dotsContainer = document.createElement('div');
      dotsContainer.id = 'hero-dots';
      heroSection.appendChild(dotsContainer);
      const dotEls = heroSlides.map((_, i) => {
        const d = document.createElement('div');
        d.className = 'hero-dot' + (i === 0 ? ' active' : '');
        d.onclick = () => goTo(i);
        dotsContainer.appendChild(d);
        return d;
      });

      let current = 0;
      function goTo(idx) {
        slideEls[current].classList.remove('active');
        dotEls[current].classList.remove('active');
        current = idx;
        slideEls[current].classList.add('active');
        dotEls[current].classList.add('active');
      }

      setInterval(() => goTo((current + 1) % heroSlides.length), 5000);
    }
  }
});
